'use client'

/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable arrow-body-style */
/* eslint-disable import/named */

import React from 'react'
import Link from 'next/link'
import Image from 'next/image'
import assetLoader from '@utils/internalImageLoader'
import Topic from '../Topic'
import styles from './styles/topicPanel.module.scss'

const TopicsPanel = ({ data }) => {
  return (
    <div className={styles.BoxContainer}>
      <div className={styles.TopicContainer}>
        <h2 className={styles.TopicTitle}>Topics</h2>
        {data?.map(topic => (
          <Topic
            src={topic?.attributes?.image?.data?.attributes?.url}
            alt={topic?.attributes?.topicName}
            name={topic?.attributes?.topicName}
            url={topic?.attributes?.url}
            key={topic?.attributes?.topicName}
            width={topic?.attributes?.image?.data?.attributes?.width}
            height={topic?.attributes?.image?.data?.attributes?.height}
          />
        ))}

        <Link href="/topics/">
          <div className={styles.AllTopics}>
            All Topics
            <div className={styles.IconWrap}>
              <Image src={`${assetLoader()}/images/arrow-right.svg`} alt="Icon" width="20" height="20" />
            </div>
          </div>
        </Link>
      </div>
    </div>
  )
}

export default TopicsPanel
